import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import AOS from 'aos';
import 'aos/dist/aos.css';

// (function ($, Drupal) {
//     Drupal.behaviors.addEvenClassToTeasers = {
//       attach: function (context, settings) {
//         // Select all <li> elements within the teasers field
//         const teaserItems = $('.field--name-field-teasers > .field__item', context);

//         // Iterate over each item and add a class to even-indexed items
//         teaserItems.each(function (index, element) {
//           if ((index + 1) % 2 === 0) {
//             $(element).attr('data-aos', 'fade-left');
//           } else {
//             $(element).attr('data-aos', 'fade-right');
//           }
//         });
//       }
//     };
//   })(jQuery, Drupal);

  AOS.init({

    duration: 1200,
  });  

// Remove no-js class from body when Javascript is activated
document.body.classList.remove('no-js');
document.body.classList.add('js');

document.addEventListener('scroll', function() {
    const fadeElements = document.querySelectorAll('.fade');
    const windowHeight = window.innerHeight;
    
    fadeElements.forEach(function(element) {
        const position = element.getBoundingClientRect();
        
        if (position.top < windowHeight - 50) {
            element.classList.add('fade-visible');
        }
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var buttons = document.querySelectorAll('[data-bs-target^="#collapse"]');
    
    buttons.forEach(function(button) {
        var targetId = button.getAttribute('data-bs-target');
        var collapseElement = document.querySelector(targetId);
        var parentEl = collapseElement.parentElement;

        button.addEventListener('click', function() {
            if (collapseElement.classList.contains('show')) {
                collapseElement.classList.remove('show');
                parentEl.classList.remove('open');
            } else {
                collapseElement.classList.add('show');
                parentEl.classList.add('open');
            }
        });
    });
});

$(document).ready(function() {
    $('.paragraph--type-image-slider .field--name-field-images .field__items').owlCarousel({
        items: 2.2,
        loop:true,
        margin:10,
        nav:true,
        navText: ["<div class='nav nav-prev'></div>","<div class='nav nav-next'></div>"]
    });

    $('.view-blog-overview .view-content').owlCarousel({
        items: 2.2,
        loop:true,
        margin:15,
        nav:true,
        navText: ["<div class='nav nav-prev'></div>","<div class='nav nav-next'></div>"]
    });
});

/* Get the current scroll position */
var prevScrollpos = window.pageYOffset;

/* Get the header element and it's position */
var headerDiv = document.querySelector("header");

window.onscroll = function() {
  var currentScrollPos = window.pageYOffset;

  /* if scrolling down, let it scroll out of view as normal */
  if (prevScrollpos <= currentScrollPos ){
//       headerDiv.classList.remove("scroll");
//   }
//   /* otherwise if we're scrolling up, fix the nav to the top */
//   else{  
      headerDiv.classList.add("scroll");
  }

  prevScrollpos = currentScrollPos;
}

if (document.body.classList.contains('page-node-type-map-page')) {
    document.addEventListener('DOMContentLoaded', () => {
        // Listen for messages from the iframe
        window.addEventListener('message', (event) => {
            if (event.data.action === 'openLightbox') {
                const { imageUrl, imageUrlAfter, state } = event.data;
                showLightbox(imageUrl, imageUrlAfter, state);
            }
        });
    
        const lightboxCloseButton = document.querySelector('#lightbox-close');
        const toggleSwitch = document.querySelector('#before-after-toggle');
    
        // Add event listener for the toggle switch
        toggleSwitch.addEventListener('change', (event) => {
            const state = event.target.checked ? 'after' : 'before';
            setLightboxState(state);
        });

        // Hide the lightbox
        function hideLightbox() {
            const lightbox = document.querySelector('#lightbox');
            lightbox.style.display = 'none';
            lightbox.classList.remove('open');
            document.body.style.overflow = ''; // Restore scrolling
        }
    
        lightboxCloseButton.addEventListener('click', () => {
            hideLightbox();
        });

        // Show the lightbox
        function showLightbox(imageUrlBefore, imageUrlAfter, state) {
            const lightbox = document.querySelector('#lightbox');
            const lightboxImage = document.querySelector('#lightbox-image');
            const lightboxImageAfter = document.querySelector('#lightbox-image-after');
            const toggleSwitch = document.querySelector('#before-after-toggle');
    
            // Set initial image and state
            lightbox.dataset.state = state;
            lightboxImage.src = imageUrlBefore;
            lightboxImageAfter.src = imageUrlAfter;
    
            // Sync the toggle switch with the state
            toggleSwitch.checked = state === 'after';
    
            // Show the appropriate image
            updateLightboxImage(state, imageUrlBefore, imageUrlAfter);
    
            lightbox.style.display = 'flex';
            lightbox.classList.add('open');
            document.body.style.overflow = 'hidden'; // Prevent scrolling
        }
    
    
        // Switch state in the lightbox
        function setLightboxState(state) {
            const lightbox = document.querySelector('#lightbox');
            const lightboxImage = document.querySelector('#lightbox-image');
            const lightboxImageAfter = document.querySelector('#lightbox-image-after');
    
            const currentState = lightbox.dataset.state;
            if (state === currentState) return; // Avoid unnecessary updates
    
            // Update the state and image based on logic
            lightbox.dataset.state = state;
            const imageUrlBefore = lightboxImage.src;
            const imageUrlAfter = lightboxImageAfter.src;
    
            updateLightboxImage(state, imageUrlBefore, imageUrlAfter);
        }
    
        // Update the visible image in the lightbox
        function updateLightboxImage(state, imageUrlBefore, imageUrlAfter) {
            const lightboxImage = document.querySelector('#lightbox-image');
            const lightboxImageAfter = document.querySelector('#lightbox-image-after');
    
            if (state === 'before') {
                lightboxImage.style.opacity = '1';
                // lightboxImage.style.display = 'block';
                lightboxImageAfter.style.opacity = '0';
                // lightboxImageAfter.style.display = 'none';
            } else if (state === 'after') {
                lightboxImage.style.opacity = '0';
                // lightboxImage.style.display = 'none';
                lightboxImageAfter.style.opacity = '1';
                // lightboxImageAfter.style.display = 'block';
            }
        }
    });
}